HistoryCtrl.$inject = ['$scope', '$state', '$stateParams', 'Authentication', 'PortalApi', 'Notification', '$translate', '$locale', '$rootScope', 'ClientCards', '$filter', 'Localization'];

function HistoryCtrl($scope, $state, $stateParams, Authentication, PortalApi, Notification, $translate, $locale, $rootScope, ClientCards, $filter, Localization) {
    var date = new Date();
    var MAX_PERIOD_IN_MONTH = 3;
    var CARD_PREPAID = 'prepaid';

    $scope.cardId = $stateParams.cardId;
    $scope.history = [];
    $scope.historyId = [];
    $scope.extractList = [];
    $scope.defaultExtract = true;
    $scope.historyLoader = false;
    $scope.openedStart = false;
    $scope.openedEnd = false;
    $scope.visibleExtractList = false;
    $scope.openSendExtract = false;
    $scope.sendOnEmail = Authentication.user ? Authentication.user.email : '';
    $scope.block_down = false;
    $scope.cards = [];
    $scope.activeHistory = !$scope.cardId ? '' : CARD_PREPAID;

    /*get access to page for Auth user or for phone history*/
        if(!Authentication.isLogged){
            if($stateParams.billsHistory){
                $scope.billsHistory = true;
            }else{
                $state.go('pages.main');
            }
        }
    /*end get access to page*/

    ClientCards.getList().then(function(response) {
      $scope.cards = ClientCards.list;
      $scope.cards.forEach(function (elem) {
        if (elem.card_type == 'prepaid') {
          $scope.cardId = elem.id;
        }
      })
    });

    $scope.dateStart = new Date(new Date().setDate(new Date().getDate() - 1));
    $scope.dateStart.setMonth($scope.dateStart.getMonth() - 2);
    $scope.dateEnd = new Date();
    // var minStartDate = new Date(new Date().setMonth($scope.dateStart.getMonth() - 10));
    var maxStartDate = new Date(new Date().setMonth(new Date().getMonth()));
    var minDateEnd = new Date(new Date().setMonth($scope.dateEnd.getMonth() - 2));
    var maxDateEnd = new Date();

    $scope.showExtractList = function () {
        $scope.visibleExtractList = !$scope.visibleExtractList;
    };

    $scope.checkAll = function(){
        $scope.defaultExtract = true;
        $scope.extractList.forEach(function (elem) {
            elem['agreed'] = true;
        })
    };

    $scope.clearAllChecked = function () {
      $scope.defaultExtract = false;
      $scope.extractList.forEach(function (elem) {
          elem['agreed'] = false;
      })

    };
    $scope.close = function () {
        $scope.openSendExtract = false;
    };

    $scope.takeDate = function(dateFrom, dateTo){

        var fromDay = dateFrom.getDate();
        if(fromDay < 10){
            fromDay = '0'+ fromDay;
        }
        var fromMounth = dateFrom.getMonth()+1;
        if(fromMounth < 10){
            fromMounth = '0'+ fromMounth;
        }
        var fromYear = dateFrom.getFullYear();

        var toDay = dateTo.getDate();
        if(toDay < 10){
            toDay = '0'+ toDay;
        }
        var toMounth = dateTo.getMonth()+1;
        if(toMounth < 10){
            toMounth = '0'+ toMounth;
        }
        var toYear = dateTo.getFullYear();

        $scope.fullDateFrom = fromDay+'.'+ fromMounth + '.' + fromYear;
        $scope.fullDateTo = toDay+'.'+ toMounth + '.' + toYear;
    };

    $scope.sendExtract = function(){
        Localization.notifyTemplate('error', 'HISTORY.SEND_EXTRACT', 5, true, $scope.sendOnEmail);
    };

    $scope.UpdateRange = function () {


        var dateEnd;
        if ($scope.dateStart.getFullYear() == date.getFullYear()) {
            minDateEnd.setMonth($scope.dateStart.getMonth());
            maxDateEnd.setMonth(date.getMonth());
            minDateEnd.setDate($scope.dateStart.getDate());
            if (maxDateEnd.getMonth() == date.getMonth()) {
                dateEnd = date.getDate();
            } else {
                dateEnd = $scope.dateStart.getDate();
            }
            maxDateEnd.setDate(dateEnd);
        } else {

            minDateEnd.setMonth($scope.dateStart.getMonth());
            minDateEnd.setFullYear($scope.dateStart.getFullYear());
            maxDateEnd.setMonth(date.getMonth());
        }
    };

    if($rootScope.useFrame && $state.current.data.iframe == false){
        document.body.classList.remove('bodyContainer');
        $state.go('pages.error404');
        $rootScope.useFrame = false;
    }

    $scope.changeDateRange = function (pos) {

        $scope.UpdateRange();

        if (pos === 'from') {
            $scope.openedStart = !$scope.openedStart;
        }

        if (pos == 'to') {
            $scope.openedEnd = !$scope.openedEnd;
        }
    };

    $scope.UpdateRange();

    $scope.dateToOptions = {
        formatDayTitle: 'MMMM yyyy',
        showWeeks: false,
        minDate: minDateEnd,
        maxDate: maxDateEnd
    };

    $scope.dateFromOptions = {
        formatDayTitle: 'MMMM yyyy',
        showWeeks: false,
        // minDate: minStartDate,
        maxDate: maxStartDate
    };

    var differenceDaysChecker = function (end, start) {
        var diff = end.getTime() - start.getTime();
        return (diff / (1000 * 60 * 60 * 24));
    };

    $scope.sendReceipt = function (payment) {
        var email = Authentication.user.email;

        if (!email) {
            Localization.notifyTemplate('error', 'NOTIFICATION.ERROR.NO_MAIL_INPROFILE', 5, true);
        }

        payment.sendReceiptLoader = true;
        if($scope.billsHistory){
            var data = {
                payment_id: payment.id,
                email: Authentication.user.email
            };
            PortalApi.sendBillToMail(data).then(
                function (res) {

                    if (res.status != 'ok') {
                        Localization.notifyTemplate('error', 'CANT_SENT_BILL_TOMAIL', 5, true, email);
                    }else{
                        Localization.notifyTemplate('success', 'BILL_SEND_TOMAIL', 5, true, email);
                    }
                },
                function (reason) {
                    Localization.notifyTemplate('error', 'CANT_SENT_BILL_TOMAIL', 5, true, email);
                }
            ).finally(function () {
                payment.sendReceiptLoader = false;
            });
        }else{
            PortalApi.sendReceipt({
                paymentId: payment.id,
                email: email
            }).then(
                function (res) {

                    if (res.status != 'ok') {
                        Localization.notifyTemplate('error', 'CANT_SENT_BILL_TOMAIL', 5, true, email);
                    }else{
                        Localization.notifyTemplate('success', 'BILL_SEND_TOMAIL', 5, true, email);
                    }
                },
                function (reason) {
                    Localization.notifyTemplate('error', 'CANT_SENT_BILL_TOMAIL', 5, true, email);
                }
            ).finally(function () {
                payment.sendReceiptLoader = false;
            });
        }
    };

    $scope.changeTab = function (tabName) {
        $scope.activeHistory = tabName;
        $scope.getHistory();
    };

    $scope.getHistory = function () {
        $scope.historyLoader = true;

        if (+$scope.dateEnd - +$scope.dateStart > MAX_PERIOD_IN_MONTH * 31 * 24 * 60 * 60 * 1000) {
            $translate('ERRORS.INCORRECT_PERIOD', {'max_period_month': MAX_PERIOD_IN_MONTH}).then(function(text) {
                Notification.error({
                    message: text,
                    delay: 5000
                });

                $scope.historyLoader = false;
            });
        } else if ($scope.activeHistory == CARD_PREPAID && $scope.cardId) {
            PortalApi.getCardHistory({
                start: $scope.dateStart,
                end: $scope.dateEnd,
                id: $scope.cardId
            }).then(function (response) {
                $scope.history = response;
                $scope.activeHistory = "prepaid";
            }).finally(function () {
                $scope.historyLoader = false;

                $scope.history.forEach(function(elem){
                    if($scope.historyId.indexOf(elem.service_id) == -1){
                        $scope.historyId.push(elem.service_id);
                        $scope.extractList.push(elem);
                    }
                });
            });
        } else {
            if(!Authentication.isLogged && $scope.billsHistory){
                var data = {
                    startDate: $scope.dateStart,
                    endDate: $scope.dateEnd,
                    limit: 0,
                    offset: 0
                };
                PortalApi.historyGetBills(data).then(function (response) {
                    $scope.history = response;
                    $scope.activeHistory = "";
                }).finally(function () {
                    $scope.historyLoader = false;
                    $scope.history.forEach(function(elem){
                        if($scope.historyId.indexOf(elem.service_id) == -1){
                            $scope.historyId.push(elem.service_id);
                            $scope.extractList.push(elem);
                        }
                    });
                });
            }else{
                PortalApi.getHistory({
                    start: $scope.dateStart,
                    end: $scope.dateEnd
                }).then(function (response) {
                    $scope.history = response;
                    $scope.activeHistory = "";
                }).finally(function () {
                    $scope.historyLoader = false;
                    $scope.history.forEach(function(elem){
                        if($scope.historyId.indexOf(elem.service_id) == -1){
                            $scope.historyId.push(elem.service_id);
                            $scope.extractList.push(elem);
                        }
                    });
                });
            }
        }
        $scope.takeDate($scope.dateStart, $scope.dateEnd);
    };

    $scope.pay = function (payment) {
        var fields = {};
        $scope.historyLoader = true;

        PortalApi.getTemplates().then(function (response) {
            var templates = response.plain();
            var autoCheck = false;

            if (Array.isArray(templates) && templates.length) {
                templates.forEach(function (template) {
                    if (template.fields && payment.template_id === template.template_id) {
                        fields = template.fields;
                        autoCheck = true;
                    }
                });
            }

            $state.go('pages.payment', {
                serviceId: payment.service_id,
                url: payment.service_id,
                amount: payment.amount,
                fields: fields,
                templateId:true,
                autoCheck: autoCheck
            });

        }, function () {
            Localization.notifyTemplate('error', 'TEMPLATE_CANT_GET', 5, true);

            $scope.historyLoader = false;
        });
    };

    $scope.getHistory($scope.cardId);
}

module.exports = HistoryCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/history/controllers/history.js
 ** module id = 260
 ** module chunks = 1
 **/